import NavigationTabs from "../Models/MicroTip/NavigationTabs";
import {
    Box
} from "@mui/material";


const MicroTip = () => {
    return (
        <Box sx={{ p: 0 }}>
            <NavigationTabs></NavigationTabs>
        </Box>
    );
};
export default MicroTip;
